import { CoreConfigGetRequest } from '../../../server/services/core/config/get.contract';

export class AppConfig {
  static portalLaunchTime: number = new Date(2025, 3, 31).getTime();
  static applicationDeadline: number;
  static paypalClientId: string;
  static paymentCurrency: string;
  static paymentPrice: number;

  static isTestSystem() {
    return location.port.length >= 4 || [
      'localhost',
      'dev.eduapplication.de',
      'test.eduapplication.de',
      //'eduapplication.de', 'www.eduapplication.de', // todo: this is only during the few days before release of phase 1
    ].includes(location.hostname.toLowerCase());
  }

  static async load() {
    const data = await new CoreConfigGetRequest().execute();
    this.portalLaunchTime = data.portalLaunchTime ?? new Date(2025, 3, 31).getTime();
    this.applicationDeadline = data.applicationDeadline ?? new Date(2025, 3, 31).getTime();
    this.paypalClientId = data.paypalClientId;
    this.paymentCurrency = data.paymentCurrency;
    this.paymentPrice = data.paymentPrice;
  }
}
